// src/wordSearchLogic.js
import { getRng } from './utils/random';

export const generateWordSearch = (size = 12, wordsList = [], seed = null) => {
  // 1. إنشاء المولد
  const rng = getRng(seed);
  
  // دالة خلط الكلمات (Fisher-Yates Shuffle) باستعمال RNG
  const shuffle = (array) => {
    let arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  // إعداد الشبكة فارغة
  const grid = Array(size).fill(null).map(() => Array(size).fill(''));
  const placedWords = [];
  
  // الاتجاهات: [يمين، تحت، قطري-تحت]
  const dirs = [[0, 1], [1, 0], [1, 1]]; 

  // تنظيف الكلمات وخلطها
  const cleanWords = wordsList.map(w => w.toUpperCase().replace(/[^A-Z]/g, ''));
  const wordsToPlace = shuffle(cleanWords);

  for (const word of wordsToPlace) {
    let placed = false;
    let attempts = 0;
    
    // نحاول نحطو الكلمة 50 مرة
    while (!placed && attempts < 50) {
      const dir = dirs[Math.floor(rng() * dirs.length)];
      const row = Math.floor(rng() * size);
      const col = Math.floor(rng() * size);
      
      // حساب نقطة النهاية
      const endRow = row + dir[0] * (word.length - 1);
      const endCol = col + dir[1] * (word.length - 1);

      // واش الكلمة غتجي داخل حدود الشبكة؟
      if (endRow >= 0 && endRow < size && endCol >= 0 && endCol < size) {
        let canPlace = true;
        // التحقق واش الطريق خاوية أو فيها نفس الحرف
        for (let i = 0; i < word.length; i++) {
          const r = row + dir[0] * i;
          const c = col + dir[1] * i;
          if (grid[r][c] !== '' && grid[r][c] !== word[i]) {
            canPlace = false;
            break;
          }
        }

        if (canPlace) {
          // وضع الكلمة حرف بحرف
          for (let i = 0; i < word.length; i++) {
            grid[row + dir[0] * i][col + dir[1] * i] = word[i];
          }
          placedWords.push({ 
            word, 
            start: { r: row, c: col }, 
            end: { r: endRow, c: endCol } 
          });
          placed = true;
        }
      }
      attempts++;
    }
  }

  // ملء الفراغات بحروف عشوائية (باستعمال Seed أيضاً)
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      if (grid[r][c] === '') {
        grid[r][c] = letters[Math.floor(rng() * letters.length)];
      }
    }
  }

  return { grid, placedWords };
};